export const SET_SCAN_TO_PRINT_PRINTER = 'SET_SCAN_TO_PRINT_PRINTER';
export const setScanToPrintPrinter = (printerId, workstationId) => ({
  type: SET_SCAN_TO_PRINT_PRINTER,
  printerId,
  workstationId,
});

export const SET_SCAN_TO_PRINT_SCALE = 'SET_SCAN_TO_PRINT_SCALE';
export const setScanToPrintScale = (scaleId) => ({
  type: SET_SCAN_TO_PRINT_SCALE,
  scaleId,
});

export const SET_SCAN_SEARCH_VALUE = 'SET_SCAN_SEARCH_VALUE';
export const setScanSearchValue = (searchValue) => ({
  type: SET_SCAN_SEARCH_VALUE,
  searchValue,
});

// Fulfillment Plan Search
export const SEARCH_FOR_SCANNED_FULFILLMENT_PLAN = 'SEARCH_FOR_SCANNED_FULFILLMENT_PLAN';
export const searchForScannedFulfillmentPlan = (searchString) => ({
  type: SEARCH_FOR_SCANNED_FULFILLMENT_PLAN,
  searchString,
});

// Order Number Search
export const SEARCH_FOR_ORDER_NUMBER = 'SEARCH_FOR_ORDER_NUMBER';
export const searchForOrderNumber = (searchValue) => ({
  type: SEARCH_FOR_ORDER_NUMBER,
  searchValue,
});

export const SEARCH_ORDER_NUMBER_SUCCESS = 'SEARCH_ORDER_NUMBER_SUCCESS';
export const searchOrderNumberSuccess = (orders) => ({
  type: SEARCH_ORDER_NUMBER_SUCCESS,
  orders,
});

export const SET_SCAN_TO_PRINT_ERRORS = 'SET_SCAN_TO_PRINT_ERRORS';
export const setErrorMessage = (errors) => ({
  type: SET_SCAN_TO_PRINT_ERRORS,
  errors,
});

export const CLEAR_ORDER_NUMBER_SEARCH = 'CLEAR_ORDER_NUMBER_SEARCH';
export const clearOrderNumberSearch = () => ({
  type: CLEAR_ORDER_NUMBER_SEARCH,
});

export const REDIRECT_TO_SHIPMENT_DETAILS = 'REDIRECT_TO_SHIPMENT_DETAILS';
export const redirectToShipmentDetails = (fulfillmentPlanId) => ({
  type: REDIRECT_TO_SHIPMENT_DETAILS,
  fulfillmentPlanId,
});

export const SELECT_FULFILLMENT_PLAN = 'SELECT_FULFILLMENT_PLAN';
export const selectFulfillmentPlan = (fulfillmentPlanId, orderGridStatus) => ({
  type: SELECT_FULFILLMENT_PLAN,
  fulfillmentPlanId,
  orderGridStatus,
});

export const RESET_SCAN_TO_PRINT_MODE = 'RESET_SCAN_TO_PRINT_MODE';
export const resetScanToPrintMode = () => ({
  type: RESET_SCAN_TO_PRINT_MODE,
});

export const SAVE_PIPELINE_JOB_ID = 'SAVE_PIPELINE_JOB_ID';
export const savePipelineJobId = (jobId) => ({
  type: SAVE_PIPELINE_JOB_ID,
  jobId,
});

export const SCAN_TO_PRINT_PRINT_HOTKEY = 'SCAN_TO_PRINT_PRINT_HOTKEY';
export const scanToPrintPrintHotkey = (isDisabled) => ({
  type: SCAN_TO_PRINT_PRINT_HOTKEY,
  isDisabled,
});

export const SCAN_TO_PRINT_LOAD_SHIPMENT_DETAILS = 'SCAN_TO_PRINT_LOAD_SHIPMENT_DETAILS';
export const loadShipmentDetails = (fulfillmentPlanId) => ({
  type: SCAN_TO_PRINT_LOAD_SHIPMENT_DETAILS,
  fulfillmentPlanId,
});

export const CLOSING_SCAN_TO_PRINT_SHIPMENT_DETAILS = 'CLOSING_SCAN_TO_PRINT_SHIPMENT_DETAILS';
export const closingScanToPrintShipmentDetails = () => ({
  type: CLOSING_SCAN_TO_PRINT_SHIPMENT_DETAILS,
});

export const UPDATE_SCAN_TO_PRINT_MODE = 'UPDATE_SCAN_TO_PRINT_MODE';
export const updateScanToPrintMode = (mode) => ({
  type: UPDATE_SCAN_TO_PRINT_MODE,
  mode,
});

export const GET_SHIPMENT_SUCCESS = 'GET_SHIPMENT_SUCCESS';
export const getShipmentSuccess = (fulfillmentPlanId) => ({
  type: GET_SHIPMENT_SUCCESS,
  fulfillmentPlanId,
});

export const CLEAR_SCAN_TO_ERRORS = 'CLEAR_SCAN_TO_ERRORS';
export const clearScanToErrors = () => ({
  type: CLEAR_SCAN_TO_ERRORS,
});

export const SCAN_SETUP_CSW = 'SCAN_SETUP_CSW';
export const setupCsw = (fulfillmentPlanId) => ({
  type: SCAN_SETUP_CSW,
  fulfillmentPlanId,
});

export const SET_SCAN_HEADER_FOCUS = 'SET_SCAN_HEADER_FOCUS';
export const setScanHeaderFocus = (inactive) => ({
  type: SET_SCAN_HEADER_FOCUS,
  inactive,
});

export const ORDER_CANNOT_BE_SHIPPED_ERROR = 'ORDER_CANNOT_BE_SHIPPED_ERROR';
export const orderCannotBeShippedError = (orderGridStatus) => ({
  type: ORDER_CANNOT_BE_SHIPPED_ERROR,
  orderGridStatus,
});

// Queue Management Actions
export const INITIALIZE_SCAN_QUEUE = 'INITIALIZE_SCAN_QUEUE';
export const initializeScanQueue = (fulfillmentPlanIds, batchName) => ({
  type: INITIALIZE_SCAN_QUEUE,
  fulfillmentPlanIds,
  batchName,
});

export const ADVANCE_QUEUE = 'ADVANCE_QUEUE';
export const advanceQueue = () => ({
  type: ADVANCE_QUEUE,
});

export const CLEAR_SCAN_QUEUE = 'CLEAR_SCAN_QUEUE';
export const clearScanQueue = () => ({
  type: CLEAR_SCAN_QUEUE,
});

export const SET_QUEUE_POSITION = 'SET_QUEUE_POSITION';
export const setQueuePosition = (currentIndex) => ({
  type: SET_QUEUE_POSITION,
  currentIndex,
});
